import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import vuetify from "./plugins/vuetify";
import i18n from "@/plugins/i18n";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@mdi/font/css/materialdesignicons.css";
import { setConfig } from "@/config";
import axios from "axios";
import VueTheMask from "vue-the-mask";

const asyncLocalStorage = {
  setItem: function (key, value) {
    return Promise.resolve().then(function () {
      localStorage.setItem(key, value);
    });
  },
  getItem: function (key) {
    return Promise.resolve().then(function () {
      return localStorage.getItem(key);
    });
  },
};

Vue.config.productionTip = false;
Vue.use(VueTheMask);

fetch("/config.json")
  .then((res) => res.json())
  .then((config) => {
    setConfig(config);
    Vue.prototype.$config = config;

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const url = config.apiUrl;
        const payload = {
          refreshToken: localStorage.getItem("refreshToken"),
        };

        const urlError = error.config.url;
        const urlRefresh = url + "/refresh";
        if (
          error.response &&
          error.response.status === 401 &&
          urlError !== urlRefresh
        ) {
          return axios
            .post(`${url}/refresh`, payload)
            .then((response) => {
              asyncLocalStorage
                .setItem("token", response.data.accessToken)
                .then(() => {
                  window.location.reload();
                });
            })
            .catch(() => {
              localStorage.clear();
              router.push({ name: "SignIn" });
            });
        }

        return Promise.reject(error);
      }
    );

    new Vue({
      store,
      router,
      vuetify,
      i18n,
      render: (h) => h(App),
    }).$mount("#app");
  })
  .catch((err) => {
    console.error("Error cargando config.json:", err);
  });
